import "../Css/home.css"

export default function ParaCards({heading , para }) {
  return (
    <div className="cards-container">
      <div className="card">
        <h4>{heading}</h4>
        <p>{para}</p>
      </div>
    </div>
  );
}
